<template>
  <!-- <v-row> -->
    <v-col cols="12" align="center" class="pl-0 pt-0 pb-0">
      <div
        class="d-flex align-self-center pl-0"
        style="height: 120px; width: 120px"
        v-if="item.attendanceData.invited"
      >
        <ejs-accumulationchart
          ref="pie"
          :theme="theme"
          style="display: block"
          align="center"
          :legendSettings="legendSettings"
          :tooltip="tooltip"
          enableSmartLables="true"
          :enableAnimation="enableAnimation"
          :center="center"
          height="120"
          width="120"
        >
          <e-accumulation-series-collection>
            <e-accumulation-series
              :palettes="palettes"
              :pointColorMapping="pointColorMapping"
              :dataSource="attendanceData"
              :startAngle="startAngle"
              :endAngle="endAngle"
              :explodeOffset="explodeOffset"
              :explodeIndex="explodeIndex"
              :radius="radius"
              xName="x"
              yName="y"
              :dataLabel="dataLabel"
              innerRadius="0%"
              explode="true"
            >
            </e-accumulation-series>
          </e-accumulation-series-collection>
        </ejs-accumulationchart>
      </div>
      <v-card
        v-else
        flat
        class="d-flex align-center"
        style="height: 120px; width: 150px"
      >
        <v-card-text class="pa-1">
          <span class="subtitle-2 font-weight-bold text--primary">
            {{ $t("agenda.hRecordNotFound") }}
          </span>
        </v-card-text>
      </v-card>
    </v-col>
    <!-- </v-row> -->
</template>
<style scoped>
</style>
<script>
import Vue from "vue";
import { Browser } from "@syncfusion/ej2-base";
import { DropDownList } from "@syncfusion/ej2-vue-dropdowns";
import {
  AccumulationChartPlugin,
  AccumulationTooltip,
  PieSeries,
  AccumulationDataLabel,
  AccumulationLegend,
} from "@syncfusion/ej2-vue-charts";
Vue.use(AccumulationChartPlugin);

let selectedTheme = location.hash.split("/")[1];
selectedTheme = selectedTheme ? selectedTheme : "Material";
let theme = (
  selectedTheme.charAt(0).toUpperCase() + selectedTheme.slice(1)
).replace(/-dark/i, "Dark");

export default Vue.extend({
  name: "AttendanceAnalysisChart",
  props: {
    item: {
      type: [Object, Array],
    },
  },
  data() {
    return {
      theme: theme,
      emptyPointSettings: { mode: "Average", fill: "red" },
      pointColorMapping: "fill",
      palettes: ["#F6B53F", "#6FAAB0", "#FF33F3", "#228B22", "#3399FF"],
      dataLabel: {
        visible: true,
        position: "Inside",
        name: "text",
        font: {
          fontWeight: "600",
        },
      },
      enableSmartLabels: true,
      enableAnimation: false,
      legendSettings: {
        visible: false,
      },
      tooltip: { enable: true, format: "${point.x} : <b>${point.y}</b>" },
      startAngle: "0",
      endAngle: "360",
      radius: "100%",
      explodeOffset: "0",
      explodeIndex: 0,
      center: { x: "50%", y: "50%" },
    };
  },
  computed: {
    attendanceData() {
      if (!this.item) {
        return;
      }
      let data = [];
      if (this.item.attendanceData.invited == 0) {
        data.push({
          x: this.$t("statistics.lblInvited"),
          y: this.item.attendanceData.invited,
          text: this.item.attendanceData.invited,
          fill: this.palettes[4],
        });
      } else if (
        this.item.attendanceData.invited &&
        this.item.attendanceData.absent &&
        this.item.attendanceData.attended
      ) {
        data.push(
          {
            x: this.$t("statistics.lblAbsent"),
            y: this.item.attendanceData.absent,
            text: `${(
              (Number(this.item.attendanceData.absent) /
                Number(this.item.attendanceData.invited)) *
              100
            ).toFixed(0)}%`,
            fill: "#ff6666",
          },
          {
            x: this.$t("statistics.lblAttended"),
            y: this.item.attendanceData.attended,
            text: `${(
              (Number(this.item.attendanceData.attended) /
                Number(this.item.attendanceData.invited)) *
              100
            ).toFixed(0)}%`,
            fill: "#009900",
          }
        );
      } else if (
        this.item.attendanceData.invited &&
        this.item.attendanceData.absent
      ) {
        data.push({
          x: this.$t("statistics.lblAbsent"),
          y: this.item.attendanceData.absent,
          text: `${(
            (Number(this.item.attendanceData.absent) /
              Number(this.item.attendanceData.invited)) *
            100
          ).toFixed(0)}%`,
          fill: "#ff6666",
        });
      } else if (
        this.item.attendanceData.invited &&
        this.item.attendanceData.attended
      ) {
        data.push({
          x: this.$t("statistics.lblAttended"),
          y: this.item.attendanceData.attended,
          text: `${(
            (Number(this.item.attendanceData.attended) /
              Number(this.item.attendanceData.invited)) *
            100
          ).toFixed(0)}%`,
          fill: "#009900",
        });
      }
      return data;
    },
  },
  provide: {
    accumulationchart: [
      AccumulationLegend,
      PieSeries,
      AccumulationTooltip,
      AccumulationDataLabel,
    ],
  },
  updated() {
    this.$nextTick(function () {
      this.$refs?.pie?.ej2Instances.refresh();
      this.$refs?.pie?.ej2Instances.removeSvg();
      this.$refs?.pie?.ej2Instances.refreshSeries();
      this.$refs?.pie?.ej2Instances.refreshChart();
    });
  },
  methods: {
    pieangle(e) {
      let angle = document.getElementById("pieangle").value;
      this.endAngle = +angle;
      this.startAngle = +angle;
      document.getElementById("anglevalue").innerHTML = angle;
    },
    pieradius(e) {
      let rad = document.getElementById("pieradius").value;
      this.radius = rad + "%";
      document.getElementById("radiusid").innerHTML = (rad / 100).toFixed(2);
    },
    pieexploderadius(e) {
      let rad = document.getElementById("pieexploderadius").value;
      this.explodeOffset = rad + "%";
      document.getElementById("exploderadius").innerHTML = (rad / 100).toFixed(
        2
      );
    },
    pieexplodeindex(e) {
      let index = document.getElementById("pieexplodeindex").value;
      this.explodeIndex = +index;
      document.getElementById("explodeindex").innerHTML = index;
    },
    piecenterx(e) {
      let x = document.getElementById("x").value;
      this.$refs.pie.ej2Instances.center.x = x + "%";
      document.getElementById("xvalue").innerHTML = x + "%";
      this.$refs.pie.ej2Instances.refresh();
      this.$refs.pie.ej2Instances.removeSvg();
      this.$refs.pie.ej2Instances.refreshSeries();
      this.$refs.pie.ej2Instances.refreshChart();
    },
    piecentery(e) {
      let y = document.getElementById("y").value;
      this.$refs.pie.ej2Instances.center.y = y + "%";
      document.getElementById("yvalue").innerHTML = y + "%";
      this.$refs.pie.ej2Instances.refresh();
      this.$refs.pie.ej2Instances.removeSvg();
      this.$refs.pie.ej2Instances.refreshSeries();
      this.$refs.pie.ej2Instances.refreshChart();
    },
  },
});
</script>
<style>
.e-accumulationchart {
  height: inherit !important;
  width: inherit !important;
}
.e-chart {
  width: inherit !important;
  height: inherit !important;
}
</style>